import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

ReactDOM.render(
  <>
  <h1>Hello World!</h1>
  <p>This is my first react app</p>
  </>
  ,document.getElementById('root')
);


